import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { useUserStore } from '@/stores/user'
import { datadogRum } from '@datadog/browser-rum'

interface AuthApi {
  logout: (params?: { redirectUrl?: string; keepToken?: boolean }) => void
}

export default defineNuxtPlugin((nuxtApp) => {
  const { setToken, setExpires } = useApolloToken()
  const { refreshConvertVariations } = useConvert()

  const authApi: AuthApi = {
    logout: async ({ redirectUrl = '/login', keepToken = false } = {}) => {
      const authStore = useAuthStore()
      const appStore = useAppStore()
      const userStore = useUserStore()

      if (!keepToken) {
        userStore.deleteSession().catch((deleteSessionError) => {
          logError(deleteSessionError)
        })
      }

      authStore.logout()

      setExpires(null)
      setToken(null)

      datadogRum.clearUser()

      // useCookie removes the token from the browser in a watcher. Without waiting, the refresh still sends the old
      // token, so the variations stay bucketed on the logged out user.
      await nextTick()

      await refreshConvertVariations()

      navigateTo(`/${appStore.locale}-${appStore.country}${redirectUrl}`)
    }
  }

  nuxtApp.provide('auth', authApi)
})
